export const ASC = 'asc';
export const DESC = 'desc';
export const ORDER_REGEX = [
  /[0-9]{3}-[0-9]{7}-[0-9]{7}$/,
  /^\d{15}$/,
  /^\d{13}$/, //Walmart Canada
];
export const TRACKING_ID_REGEX = [
  /^\d{12,14}$/, // Fedex
  /D\d{21}$/, // Canpar
  /FB[DX]-\d+$/, // Flashbox
  /P\d{10}$/, // GLS
  /^1Z[a-zA-Z\d]{16,18}$/, // UPS
  /^\d{16}$/, //Canada Post
  /E\d{10}$/, // GLS US
];
export const APPLY = 'Apply';
export const CANCEL = 'Cancel';

export const UPLOAD_FILE = 'Upload File';
export const UPLOAD_LOGO = 'Upload Logo';
export const DELETE_LOGO = 'Delete Logo';
export const SAVE = 'Save';
export const NEXT = 'Next';
export const DELETE = 'Delete';
export const NAVIGATE_LEFT = 'Previous';
export const NAVIGATE_RIGHT = 'Next';

export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_OWNER = 'ROLE_OWNER';
export const ROLE_MASTER_ADMIN = 'ROLE_MASTER_ADMIN';
export const ROLE_MANAGER = 'ROLE_MANAGER';

export const FILE_CHIP_MAX_TEXT_LENGTH = 25;

export const START_INDEX = 0;

export const getByteArray = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const arrayBuffer = reader.result;
      const uint8array = new Uint8Array(arrayBuffer);
      resolve(Array.from(uint8array)); // real byte[]
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const DEFAULT_PDF_ZOOM = 1.5;
